type Game8Map = {
  intro: string[]
  groups: Array<{
    groupName: string
    groupImg: string
    items: Array<{
      id: string
      label: string
      img: string
      group: string
      comment: string
    }>
  }>
  errorComments: string[]
}

// forester, woodsman, kindergarten
export const Game8Map: Game8Map = {
  intro: [
    'Při hospodaření v lese a při pracech souvisejících s pěstováním, výchovou a těžbou lesa se uplatí mnoho profesí. Víš, v jakém prostředí prostředí se pohybují a co ke své práci potřebují lesník, dřevorubec a dělnice v lesní školce?',
    'K vybraným profesím přiřaď správné fotografie.',
  ],
  groups: [
    {
      groupName: 'Lesník',
      groupImg: require('../assets/game8/forester/00_lesnik-min.jpg').default,
      items: [
        {
          id: 'bag',
          label: 'Lesnická brašna',
          img: require('../assets/game8/forester/01_lesnicka-brasna.jpg').default,
          group: 'A',
          comment:
            'Bez lesnické brašny se neobejde žádný lesník. Má v ní vše, co každý den ke své práci v lese potřebuje. Například lesnické mapy, zadávací listy pro dřevorubce, sprej ke značení stromů nebo kalkulačku.',
        },
        {
          id: 'can',
          label: 'Sprej ke značení stromů',
          img: require('../assets/game8/forester/02_sprej-ke-znaceni-stromu.jpg').default,
          group: 'A',
          comment:
            'Spreje ke značení stromů mohou mít různé barvy. Lesníci tečkou označí stromy určené k pokácení. Může se jednat o nemocné a poškozené stromy, nebo o stromy zralé, které jsou pečlivě vybírány přesně na míru zákazníkovi – kupci dříví.',
        },
        {
          id: 'seedling',
          label: 'Sazenice',
          img: require('../assets/game8/forester/03_sazenice.jpg').default,
          group: 'A',
          comment:
            'K práci lesníka patří rozhodování, jakými druhy dřevin se bude zalesňovat. Hlídá kvalitu nakoupených sazenic i to, aby sazenicím před vysazením do lesa nezasychaly kořeny. Dohlíží také na práci lesních dělníků při zalesňování.',
        },
        {
          id: 'transport',
          label: 'Odvoz dřeva',
          img: require('../assets/game8/forester/04_odvoz-dreva.jpg').default,
          group: 'A',
          comment:
            'K povinnostem lesníka patří dohlížet i na odvoz dříví. Každý zákazník a zpracovatel musí dostat přesně takové dříví, jaké si objednal. Pokácené kmeny se liší druhem dřeviny, délkou a průměrem kmene i kvalitou dřeva.',
        },
        {
          id: 'seedlings2',
          label: 'Přirozené zmlazení',
          img: require('../assets/game8/forester/05_prirozene-zmlazeni.jpg').default,
          group: 'A',
          comment:
            'Malé semenáčky vyrostou někdy ze spadaných semen okolních stromů samy. Říká se jim přirozené zmlazení. Lesník z něj má vždy radost a dohlíží, aby ho nepoškodili dřevorubci při těžbě nebo zvěř okusem. Pokud je příliš husté, nechá ho prostřihat nůžkami, aby lépe rostlo.',
        },
        {
          id: 'treesToCut',
          label: 'Porost k těžbě',
          img: require('../assets/game8/forester/06_porost-k-tezbe.jpg').default,
          group: 'A',
          comment:
            'Nasprejovanými tečkami lesník vyznačuje stromy určené k těžbě. Připravuje tak les pro dřevorubce, aby viděli, který strom je třeba z lesa odstranit, protože je nemocný a brání ostatním v růstu, nebo který se bude nejvíce hodit zákazníkovi – kupci dříví.',
        },
        {
          id: 'pestCtrl',
          label: 'Kontrola vývoje kůrovců',
          img: require('../assets/game8/forester/08_kontrola-vyvoje-kurovcu.jpg').default,
          group: 'A',
          comment:
            'Lesníci na hromadách dříví připravených k odvozu z lesa kontrolují vývoj brouků kůrovců. Díky tomu, že jsou stromy pokácené, mohou jejich kmeny prohlédnout od paty až po špičku. Jsou tu ještě malé larvy nebo už se z kukel líhnou dospělí brouci? Lesníci potom rozhodnou, jak les proti kůrovcům nejlépe chránit.',
        },
        {
          id: 'fence',
          label: 'Oplocenka',
          img: require('../assets/game8/forester/09_oplocenka.jpg').default,
          group: 'A',
          comment:
            'Oplocenka chrání mladé stromky, aby je neokusovala lesní zvěř. Lesník všechny oplocenky ve svém revíru pravidelně kontroluje. Např. vítr by mohl vyvrátit strom a tím oplocenku rozbít. Zvěř by tak měla ke stromkům cestu volnou a oplocenka by ztratila svou funkci – stromky by byly okousané a špatně odrůstaly.',
        },
      ],
    },
    {
      groupName: 'Dřevorubec',
      groupImg: require('../assets/game8/woodsman/00_drevorubec.jpg').default,
      items: [
        {
          id: 'chainsaw',
          label: 'Motorová pila',
          img: require('../assets/game8/woodsman/01_motorova-pila.jpg').default,
          group: 'B',
          comment:
            'Dnes již dřevorubci v lese nedobývají stromy sekyrou a pilou břichatkou, ale motorovou pilou. Aby jim dlouho vydržela a dobře sloužila, musí se o ni pečlivě starat: několikrát za směnu ji brousit řetěz, doplňovat olej a benzín a čistit ji od prachu a pilin.',
        },
        {
          id: 'pliers',
          label: 'Dřevorubecké kleště',
          img: require('../assets/game8/woodsman/02_drevorubecke-kleste.jpg').default,
          group: 'B',
          comment:
            'Dřevorubecké kleště dřevorubci používají na přemisťování menších kmenů a klád. Kleště se do dřeva zarazí a dřevorubci pak s kmeny dokážou lépe manipulovat. S jejich pomocí například popotahují klády na hromady.',
        },
        {
          id: 'meter',
          label: 'Pásmo',
          img: require('../assets/game8/woodsman/03_pasmo.jpg').default,
          group: 'B',
          comment:
            'Pásmo. Po skácení každého stromu dřevorubec kmen změří a rozřeže na kusy podle zadání lesníka. Hlídá přitom délku kmene, kterou měří pásmem, průměr, který měří průměrkou, a kvalitu dřeva.',
        },
        {
          id: 'meter2',
          label: 'Průměrka',
          img: require('../assets/game8/woodsman/04_prumerka.jpg').default,
          group: 'B',
          comment:
            'Dřevorubec používá průměrku po skácení každého stromu. Délku kmene změří pásmem a jeho průměr průměrkou. Průměr se měří uprostřed kmene. Pak už je jednoduché spočítat objem dřeva, které se z lesa získalo.',
        },
        {
          id: 'gloves',
          label: 'Antivibrační rukavice',
          img: require('../assets/game8/woodsman/05_antivibracni-rukavice.jpg').default,
          group: 'B',
          comment:
            'Dřevorubec používá rukavice, které jsou na straně dlaně vypolstrované. Nazývají se antivibrační a mají za úkol chránit dřevorubcovy ruce. Motorová pila totiž působí otřesy a vibrace.',
        },
        {
          id: 'sign',
          label: 'Nebezpečí úrazu',
          img: require('../assets/game8/woodsman/06_nebezpeci-urazu.jpg').default,
          group: 'B',
          comment:
            'Těžit v lese stromy není lehké, dřevorubec musí strom dobře nasměrovat, aby padl přesně tam, kam je potřeba. Padající kmeny a větve jsou nebezpečné, proto uslyšíte-li v lese zvuk motorové pily, nikdy se k němu nepřibližujte, ale odejděte do bezpečné vzdálenosti.',
        },
        {
          id: 'sign2',
          label: 'Popis pokáceného kmene',
          img: require('../assets/game8/woodsman/07_popis-pokaceneho-kmene.jpg').default,
          group: 'B',
          comment:
            'Rozměry pokáceného stromu dřevorubec napíše na čelo kmene. Nejprve jenom v rychlosti a křídou – délka (4 m) lomená průměrem (32 cm) kmene. Modrá křída se však může smazat, proto dřevorubec po skončení těžby vezme číslovačku a na každý kmen vyrazí ty samé údaje ještě jednou, včetně pořadového čísla kmene (5225).',
        },
        {
          id: 'pestCtrl2',
          label: 'Odkornění',
          img: require('../assets/game8/woodsman/08_odkorneni.jpg').default,
          group: 'B',
          comment:
            'Někdy je třeba v lese pokácet i stromy napadené brouky kůrovci, aby se v lese nemohli více rozšířit. Dřevorubci poté poražené kmeny zbaví kůry – odkorní. K tomu používají škrabák. Protože se kůrovci vyvíjí pod kůrou stromů, odkornění jim zabrání v dokončení vývoje a kůrovci tak nemohou les ohrožovat.',
        },
        {
          id: 'branching',
          label: 'Odvětvování',
          img: require('../assets/game8/woodsman/09_odvetvovani.jpg').default,
          group: 'B',
          comment:
            'Během odvětvování - zbavování pokáceného stromu větví - dřevorubec stromy zároveň měří pásmem. Podle toho je hned zkracuje na potřebné délky. Díky tomu se při vytahování z lesa snadno pohybují mezi stojícími stromy a příliš je neodřou.',
        },
        {
          id: 'treeLogging',
          label: 'Skácení stromu',
          img: require('../assets/game8/woodsman/10_skaceni-stromu.jpg').default,
          group: 'B',
          comment:
            'Dřevorubci pracují v lese i v zimě. Dokonce je zimní období pro těžbu lesních dřevin vhodnější, protože se tolik nepoškodí lesní půda a vůbec celý les. Dřevorubec musí strom dobře nasměrovat, aby padl tam, kam je potřeba.',
        },
      ],
    },
    {
      groupName: 'Dělnice v lesní školce',
      groupImg: require('../assets/game8/kindergarten/00_delnice-v-lesni-skolce.jpg').default,
      items: [
        {
          id: 'seedlings2',
          label: 'Malé semenáčky',
          img: require('../assets/game8/kindergarten/01_male-semenacky.jpg').default,
          group: 'C',
          comment:
            'Dělníci nebo dělnice v lesní školce vysévají semínka lesních dřevin do speciálních substrátů. Substráty semínkům poskytují dostatek potřebných živin. Klíčení semen ovlivňuje i teplota a vlhkost. Ze semínek vyrostou malé semenáčky, základ budoucího lesa.',
        },
        {
          id: 'seedlings3',
          label: 'Pletí ve foliovníku',
          img: require('../assets/game8/kindergarten/02_pleti-ve-foliovniku.jpg').default,
          group: 'C',
          comment:
            'O semenáčky i starší sazenice se dělnice v lesní školce pečlivě starají. Vytrhávání plevele patří k jejich každodenním činnostem. Plevel malé stromky dusí a ubírá jim živiny a světlo.',
        },
        {
          id: 'seedlings4',
          label: 'Postřik sazenic',
          img: require('../assets/game8/kindergarten/03_postrik-sazenic.jpg').default,
          group: 'C',
          comment:
            'Proti napadení houbovými chorobami a poškození škůdci se ve školce budoucí lesní stromky ošetřují různými druhy postřiků.',
        },
        {
          id: 'seedlings5',
          label: 'Školkování semenáčků',
          img: require('../assets/game8/kindergarten/04_skolkovani-semenacku.jpg').default,
          group: 'C',
          comment:
            'Když semenáčky vyrostlé ze semínek více povyrostou, přesazují se na záhony nebo do plastových obalů - kontejnerů. Přesazování do volné půdy se nazývá školkování.',
        },
        {
          id: 'greenhouse',
          label: 'Foliovník',
          img: require('../assets/game8/kindergarten/05_foliovnik.jpg').default,
          group: 'C',
          comment:
            'Často se sazenice pěstují v zakrytých fóliovnících. Dělnice v nich mohou snáze regulovat teplotu nebo vlhkost. Sazenice zde také neohrožuje špatné počasí jako je déšť nebo kroupy.',
        },
        {
          id: 'watering',
          label: 'Zavlažování záhonu',
          img: require('../assets/game8/kindergarten/06_zavlazovani-zahonu.jpg').default,
          group: 'C',
          comment:
            'Zavlažování záhonů se sazenicemi je nezbytným předpokladem pro jejich zdárný růst zvláště za horkých letních dnů, kdy je vody v půdě nedostatek a klesá i přirozená vlhkost vzduchu.',
        },
        {
          id: 'seedlingsInBox',
          label: 'Sazenice v přepravkách',
          img: require('../assets/game8/kindergarten/07_sazenice-v-prepravkach.jpg').default,
          group: 'C',
          comment:
            'Před expedicí do lesa se sazenice ze záhonů vyzvedávají a skládají do přepravek, aby se s nimi během dopravy dělníkům snáze manipulovalo.',
        },
        {
          id: 'seedlingsTransport',
          label: 'Nakládání sazenic',
          img: require('../assets/game8/kindergarten/08_nakladani-sazenic.jpg').default,
          group: 'C',
          comment:
            'Sazenice připravené k expedici se mohou i zabalit. Důležité je zamezit přitom vysýchání kořenů. Kořeny sazenic jsou na vysýchání velmi citlivé. Pokud k němu dojde, sazenice v lese vůbec nezakoření, a celá zásilka sazenic je tak znehodnocena.',
        },
        {
          id: 'seedlingExample',
          label: 'Javorová sazenice',
          img: require('../assets/game8/kindergarten/09_javorova-sazenice.jpg').default,
          group: 'C',
          comment:
            'V lesní školce se pěstují různé druhy semenáčku a sazenic. Liší se velikostí, stářím, nebo způsobem pěstování podle toho, kam budou v lese vysazeny. Tato javorová sazenice má kořeny kryté půdním balem, což ji umožňuje vysadit do méně příznivých lesních podmínek.',
        },
        {
          id: 'seedlings6',
          label: 'Záhon ve školce',
          img: require('../assets/game8/kindergarten/10_zahon-ve-skolce.jpg').default,
          group: 'C',
          comment:
            'Lesní školka z dálky vypadá jako zahrada s dlouhatánskými záhony. Na nich ale místo kedluben a ředkviček rostou malé doubky, smrčky, javory, buky, lípy, borovičky a mnohé další druhy lesních dřevin. Lesní školky se zakládají v lese, aby byly semenáčky a sazenice od malička zvyklé na lesní půdu.',
        },
      ],
    },
  ],
  errorComments: [
    'Nene, zkus to jinak.',
    'Vedle jak ta jedle.',
    'Kdepak, zkus to jinak.',
    'Prach a broky, to není ono.',
  ],
}
